/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Group_B_FallbackInputs */



/**
* | output |
* | --- |
* | "Group B" |
*
* @param {Compare_Event_Groups_Group_B_FallbackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_group_b_fallback = /** @type {((inputs?: Compare_Event_Groups_Group_B_FallbackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Group_B_FallbackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループB")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo B")
	return /** @type {LocalizedString} */ ("Group B")
});